const faqData = {
  "get-started": [
    {
      question: "What is TripSecure?",
      answer: "TripSecure offers comprehensive travel protection and convenience through four divisions:\n• Travel Insurance – Pay-as-you-go cover for domestic and international trips.\n• Travel, Tour & Smart Logistics – Book flights, group tours, and delivery services with ease.\n• Safety Services – Access airport pickup, roadside support, and security coverage.\n• Media & Events – Travel storytelling, brand partnerships, and awareness campaigns."
    },
    {
      question: "How do I buy travel insurance?",
      answer: "You can purchase online through our USSD, website OR App. Select your trip details, choose a plan, and make payment via mobile money, card, or bank transfer. You'll instantly receive your e-policy via email or SMS."
    },
    {
      question: "Can I pay in instalments?",
      answer: "Yes! For selected travel packages and pilgrimages, TripSecure allows flexible monthly instalment payments. You can spread your payments over several months before your travel date."
    },
    {
      question: "How do I file a claim?",
      answer: "Visit the Claims Support section and submit:\n• Your policy number\n• Proof of travel (e.g., ticket or itinerary)\n• Supporting documents (e.g., medical report, police report, receipts)\nOur team will review and get back to you within 3–5 working days."
    },
    {
      question: "Is my insurance valid abroad?",
      answer: "Yes, depending on your selected plan. TripSecure offers both domestic and international travel insurance that covers medical emergencies, trip cancellations, and lost luggage."
    }
  ],
  "policy-management": [
    {
      question: "How do I download my policy?",
      answer: "Log in to your TripSecure account and navigate to 'My Policies' section where you can download your policy documents."
    },
    {
      question: "Can I update my travel details?",
      answer: "Yes, you can update your contact or travel info under 'My Profile' in your TripSecure dashboard."
    },
    {
      question: "How do I cancel my policy?",
      answer: "Contact our support team for cancellation assistance. You can reach us at info@tripsecuregh.com or call +233 (0)20 401 4370."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept Mobile Money, Visa/MasterCard, and bank transfers through our secure payment gateway."
    },
    {
      question: "What if I miss an instalment payment?",
      answer: "Log in to your dashboard to update your billing or contact support immediately to avoid service interruption."
    }
  ],
  "safety-services": [
    {
      question: "What safety services does TripSecure provide?",
      answer: "We provide:\n• Verified airport pickups and transfers\n• Roadside assistance and emergency response\n• 24/7 safety helpline for travellers\n• Real-time tracking and trip updates\n• Secure courier and parcel delivery"
    },
    {
      question: "How do I contact emergency support?",
      answer: "For emergencies, call our 24/7 Safety Line: +233 (0)20 401 4370. For international travellers, we partner with global emergency assistance networks."
    },
    {
      question: "Are your drivers verified?",
      answer: "Yes, we work only with vetted drivers and licensed transport partners. You'll receive driver and vehicle details before pickup, and all rides are insured under TripSecure's safety cover."
    },
    {
      question: "How do I track my delivery?",
      answer: "Every package is insured and trackable. You'll receive real-time updates and can verify delivery through sender & receiver confirmation."
    },
    {
      question: "What safety tips should I follow before traveling?",
      answer: "Before any trip:\n• Verify your travel insurance is active\n• Share your trip details with family/friends\n• Pack a first-aid kit and essential medications\n• Keep emergency contacts accessible\n• Review local travel advisories"
    }
  ],
  "travel-tours": [
    {
      question: "What types of tours do you offer?",
      answer: "We offer group tours, pilgrimages, flight bookings, and custom itineraries. You can browse available tours, flight deals, and holiday packages on our platform."
    },
    {
      question: "Can I book directly online?",
      answer: "Yes, you can book directly online or request a custom itinerary through our platform."
    },
    {
      question: "Do you offer group trip payments?",
      answer: "For group trips, you can pay monthly and track your balance through your TripSecure account."
    },
    {
      question: "What's included in your tours?",
      answer: "Our tours include verified accommodation and transport partners, pre-trip safety briefings, travel alerts, and emergency medical support during travel."
    },
    {
      question: "Can I customize my travel itinerary?",
      answer: "Yes, we offer custom itinerary planning. Contact our travel team at info@tripsecuregh.com for personalized travel arrangements."
    }
  ],
  "contact-support": [
    {
      question: "How can I contact customer support?",
      answer: "You can reach us via:\n• Email: info@tripsecuregh.com\n• Phone: +233 (0)20 401 4370\n• WhatsApp: +233 (0)20 401 4370\n• Office: Dokua Plaza, Accra, Ghana"
    },
    {
      question: "What are your operating hours?",
      answer: "Customer Support: Monday – Saturday, 8:00 AM – 4:00 PM (GMT)\nEmergency Support: 24/7 available"
    },
    {
      question: "How quickly do you respond to emails?",
      answer: "We aim to reply to general inquiries within 24 hours. Claims and policy support responses are provided within 3–5 working days."
    },
    {
      question: "Do you have a claims hotline?",
      answer: "Yes, for claims support call +233 (0)55 123 4567 or email claims@tripsecuregh.com"
    },
    {
      question: "Can I visit your office?",
      answer: "Yes, our corporate office is located at Dokua Plaza, Accra, Ghana. Office hours: Monday-Friday 8:00 AM-4:00 PM, Saturday 10:00 AM-3:00 PM"
    }
  ],
  "about-us": [
    {
      question: "What is TripSecure's vision?",
      answer: "To become Africa's most trusted travel safety brand, enabling every traveller to explore freely, knowing they are protected wherever they go."
    },
    {
      question: "What makes TripSecure different?",
      answer: "We are Africa's first all-in-one travel safety and protection ecosystem, combining insurance, tourism, logistics, and safety into one seamless digital experience."
    },
    {
      question: "Where is TripSecure based?",
      answer: "TripSecure is headquartered in Ghana with expanding operations across Africa. Our corporate office is located at Dokua Plaza, Accra, Ghana."
    },
    {
      question: "What is TripSecure's motto?",
      answer: "'Securing the Future of Travel in Africa' - It's not just a slogan, it's our philosophy. Because every trip, every package, and every person deserves protection."
    },
    {
      question: "How can I partner with TripSecure?",
      answer: "We welcome partnerships with travel service providers, safety professionals, logistics companies, and media/event vendors. Contact us at info@tripsecuregh.com"
    }
  ]
};

export default faqData;